import { EnumInvoiceType } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

export const getEnumInvoiceTypeLabel = (type: EnumInvoiceType) => {
    switch (type) {
        case EnumInvoiceType.Invoice:
            return 'Rechnung';
        case EnumInvoiceType.CreditNote:
            return 'Gutschrift';
        case EnumInvoiceType.Cancellation:
            return 'Storno';
        default:
            return 'Unbekannt';
    }
};

export const invoiceTypes: SelectOption<EnumInvoiceType>[] = [
    { name: 'invoice', label: getEnumInvoiceTypeLabel(EnumInvoiceType.Invoice), value: EnumInvoiceType.Invoice },
    { name: 'credit', label: getEnumInvoiceTypeLabel(EnumInvoiceType.CreditNote), value: EnumInvoiceType.CreditNote },
    {
        name: 'cancel',
        label: getEnumInvoiceTypeLabel(EnumInvoiceType.Cancellation),
        value: EnumInvoiceType.Cancellation,
    },
];
